import { z } from "zod";
import { TransactionReviewField } from "@common/types/transactionFieldReview";

export const transactionReviewFieldEnum = z.nativeEnum(TransactionReviewField);

export const transactionFieldReviewSchema = z.object({
    id: z.string().uuid(),
    transactionId: z.number(),
    userId: z.number(),
    field: transactionReviewFieldEnum,
    createdAt: z.coerce.date(),
});
export type TransactionFieldReviewDto = z.infer<
    typeof transactionFieldReviewSchema
>;

export const addFieldReviewsBodySchema = z.object({
    fields: z.array(transactionReviewFieldEnum).min(1),
});
export type AddFieldReviewsBody = z.infer<typeof addFieldReviewsBodySchema>;

/**
 * Returns the set of fields the given user has reviewed for a transaction.
 *
 * The add/revoke endpoints operate on the current user, so cell state and
 * "already reviewed" checks must only consider the current user's reviews.
 */
export const getUserReviewedFields = (
    fieldReviews: TransactionFieldReviewDto[] | undefined,
    userId: number | undefined,
): Set<TransactionReviewField> =>
    new Set(
        (fieldReviews ?? [])
            .filter((review) => review.userId === userId)
            .map((review) => review.field),
    );
